var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":_vm.size,"width":_vm.size,"viewBox":"0 0 20 20","fill":"currentColor"}},[_c('path',{attrs:{"d":"M 10 10 m -7.5 0 a 7.5 7.5 0 1 0 15 0 a 7.5 7.5 0 1 0 -15 0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }